import { Cart, CartTotalResponse } from '@diamond/shared/types';
import { useMemo } from 'react';

import { CartItemPromo, processCartItemPromo } from '../cart/promo-processing';

export interface CartItemPriceData {
  displayPrice: number;
  originalPrice: number;
  discountPercentage: number;
  hasDiscount: boolean;
  promoLabel?: string;
  promoDeductionAmount: number;
  promoIsDiscount: boolean;
}

export const useCartItemPrice = (
  item: Cart,
  cartTotalData?: CartTotalResponse,
  compiledPromo?: any
): CartItemPriceData => {
  return useMemo(() => {
    const processedPromo = processCartItemPromo(
      item,
      cartTotalData,
      compiledPromo
    );

    return {
      displayPrice: processedPromo.displayPrice,
      originalPrice: item.product.prices[0].price,
      discountPercentage: processedPromo.discountPercentage,
      hasDiscount:
        processedPromo.hasDiscount || processedPromo.hasBundledDiscount,
      promoLabel: processedPromo.hasBundledDiscount ? 'Bundled' : undefined,
      promoDeductionAmount: processedPromo.promoDeductionAmount,
      promoIsDiscount: processedPromo.promoIsDiscount,
    };
  }, [item, cartTotalData, compiledPromo]);
};
